import * as React from "react";
import styles from './editor.module.scss';

//Re-usable function for alerts

interface AlertProps extends isShowingAlertProps {
    setAlert: React.Dispatch<React.SetStateAction<isShowingAlertProps>>,
    isShowingAlert: isShowingAlertProps
};
interface isShowingAlertProps {
    message?: any;
    send?: boolean;
    isSubmit?: boolean;
}

export default function Alert({ setAlert, isShowingAlert }: AlertProps): JSX.Element {
    return (
        <div>
            <div
                className={`alert alert-success ${isShowingAlert.send ? styles.alertShown : styles.alertHidden} ${isShowingAlert.isSubmit ? styles.greenAlert : styles.redAlert}`}
                onTransitionEnd={() => setAlert((isShowingAlert: { message: any; }) => ({message: isShowingAlert.message, send: false}))}
            >
                <strong>{isShowingAlert.message}</strong>
            </div>
        </div>
    );
};